import { Navigate, Route, Routes } from "react-router-dom";
import { AppLayout } from "./layouts/AppLayout";
import { PublicLayout } from "./layouts/PublicLayout";
import { ApplicationPage } from "./pages/ApplicationPage";
import { LandingPage } from "./pages/LandingPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { ProcessingPage } from "./pages/ProcessingPage";
import { ResultsPage } from "./pages/ResultsPage";
import { RejectionCheckPage } from "./pages/RejectionCheckPage";
import { SubmissionPackPage } from "./pages/SubmissionPackPage";
export default function App() {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route index element={<LandingPage />} />
        <Route path="/rejection-check" element={<RejectionCheckPage />} />
      </Route>
      <Route
        path="/assessment/new"
        element={
          <AppLayout>
            <ApplicationPage />
          </AppLayout>
        }
      />
      <Route
        path="/assessment/current"
        element={
          <AppLayout>
            <ApplicationPage />
          </AppLayout>
        }
      />
      <Route
        path="/assessment/:id/processing"
        element={
          <AppLayout>
            <ProcessingPage />
          </AppLayout>
        }
      />
      <Route
        path="/assessment/:id/results"
        element={
          <AppLayout>
            <ResultsPage />
          </AppLayout>
        }
      />
      <Route
        path="/assessment/:id/submission-pack"
        element={
          <AppLayout>
            <SubmissionPackPage />
          </AppLayout>
        }
      />
      <Route
        path="/application/new"
        element={<Navigate to="/assessment/new" replace />}
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
